import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative min-h-screen flex flex-col items-center justify-center px-4 sm:px-6 overflow-hidden" data-id="element-59">
      {/* Subtle animated radial gradient glow */}
      <motion.div className="absolute inset-0 z-0 flex items-center justify-center opacity-20 pointer-events-none" animate={{
      scale: [1, 1.05, 1],
      opacity: [0.05, 0.15, 0.05]
    }} transition={{
      duration: 10,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-60">
        <div className="w-[400px] h-[400px] sm:w-[600px] sm:h-[600px] md:w-[800px] md:h-[800px] rounded-full bg-brand-gold blur-[100px] md:blur-[150px]" data-id="element-61" />
      </motion.div>

      <div className="z-10 flex flex-col items-center text-center w-full max-w-4xl" data-id="element-62">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1.0,
        ease: 'easeOut'
      }} className="mb-10 sm:mb-16 md:mb-20 flex flex-col items-center" data-id="element-63">
          <h1 className="font-logo text-4xl sm:text-6xl md:text-8xl tracking-[0.3em] sm:tracking-[0.45em] uppercase text-brand-gold font-light mb-2 sm:mb-4" data-id="element-64">
            Pollock
          </h1>
          <h2 className="font-logo text-base sm:text-xl md:text-2xl tracking-[0.35em] sm:tracking-[0.5em] uppercase text-brand-gold font-light" data-id="element-65">
            Ventures
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4,
        ease: 'easeOut'
      }} className="flex flex-col items-center" data-id="element-66">
          <p className="font-heading text-2xl sm:text-3xl md:text-5xl text-brand-offWhite mb-12 sm:mb-16 font-extralight uppercase tracking-[0.1em] sm:tracking-[0.15em]" data-id="element-67">
            Investing in what's next.
          </p>

          <motion.div className="w-px h-20 sm:h-32 bg-gradient-to-b from-brand-gold/60 to-transparent" initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} transition={{
          duration: 1.0,
          delay: 1.0,
          ease: 'easeInOut'
        }} data-id="element-68" />
        </motion.div>
      </div>
    </section>;
}